var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "CardBodyItem",
    { attrs: { label: _vm.label, wide: "" } },
    [
      _c("CardSingleChip", {
        attrs: { item: _vm.chipDetails, withAvatar: _vm.withAvatar },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }